import styled from "@emotion/styled";

export const Root = styled.div({
    padding: "5px 0",
});
